import { Table } from 'antd';
import React from 'react';

import type { RevenueStatementTableProps } from '@app/pages/Analytics/RevenueStatement/types';
import { transformRevenueStatementToTableData } from '@app/pages/Analytics/RevenueStatement/utils';

const HEADER_HEIGHT = 380;

export const RevenueStatementTable: React.FC<RevenueStatementTableProps> = ({
  isLoading,
  tableData,
}) => {
  const { dataSource, columns } =
    transformRevenueStatementToTableData(tableData);

  return (
    <Table
      bordered
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      loading={isLoading}
      className="table-border-dark"
      rowClassName={(record) =>
        record.key === 'total' ? 'cash-table-total-row' : ''
      }
      scroll={{ x: 'max-content', y: `calc(100vh - ${HEADER_HEIGHT}px)` }}
    />
  );
};
